/**
 * Converia.Core.module
 *
 * Converia.SiteStructure.View
 */

Converia.Core.module('Converia.SiteStructure.View', function () {
    /**
     * View
     * 
     * @param beforeDomElement
     * @constructor
     */
    var View = function (beforeDomElement) {
        this.domElement = document.createElement("div");
        this.articleBrowserSelectElement = null;
        $(this.domElement).insertAfter(beforeDomElement);
    };

    /**
     * View.prototype.getDomElement
     * 
     * @returns {HTMLDivElement | *}
     */
    View.prototype.getDomElement = function () {
        return this.domElement;
    };

    /**
     * View.prototype.getArticleBrowserSelectElement
     * 
     * @returns {null|*|jQuery}
     */
    View.prototype.getArticleBrowserSelectElement = function () {
        return this.articleBrowserSelectElement;
    };

    /**
     * View.prototype.showConfirmDialog
     * 
     * @returns {*|Converia.Core.Dialog}
     */
    View.prototype.showConfirmDialog = function () {
        var buttons = [
            {
                name: 'confirm',
                label: BEGUI.getInstance().translate('Converia_Admin_Module_Cms_SiteStructure_row_settings_remove_column_confirm'),
                class: 'button-delete'
            },
            {
                name: 'abort',
                label: BEGUI.getInstance().translate('Converia_Admin_Module_Cms_SiteStructure_row_settings_remove_column_abort'),
                class: 'button-cancel'
            }
        ];

        var dialog = BEGUI.Modal.instance.showDialog(
            BEGUI.getInstance().translate('Converia_Admin_Module_Cms_SiteStructure_row_settings_remove_column'),
            buttons,
            BEGUI.getInstance().translate('Converia_Admin_Module_Cms_SiteStructure_row_settings_remove_column_head')
        );

        return dialog;
    };

    /**
     * View.prototype.clear
     */
    View.prototype.clear = function () {
        $(this.domElement).empty();
    };

    /**
     * View.prototype.render
     * 
     * @param model
     */
    View.prototype.render = function (model) {
        var columns = model.getColumns();
        var columnLength = columns.length;

        renderColumnSplitElement(
            this.domElement,
            model.getAllSplitOptions(),
            model.getColumnSplit()
        );

        var columnWrapper = renderColumnWrapper(this.domElement);

        for (var columnIndex = 0; columnIndex < columnLength; columnIndex++) {
            var columnCssClass = model.getColumnCssClassFor(columnIndex);

            renderColumn(
                columnWrapper,
                columns[columnIndex],
                columnIndex,
                columnCssClass
            );
        }

        this.articleBrowserSelectElement = renderArticleBrowserSelectHelper(this.domElement);
        $(this).trigger('rendered');
    };

    /**
     * renderColumnWrapper
     * 
     * @param domElement
     * @returns {*|jQuery}
     */
    function renderColumnWrapper(domElement) {
        var wrapperHtml = [
            '<div class="row-cms">' +
            '</div>'
        ].join('');

        var wrapper = $(wrapperHtml).get(0);
        $(domElement).append(wrapper);

        return wrapper;
    }

    /**
     * renderColumn
     * 
     * @param domElement
     * @param column
     * @param columnIndex
     */
    function renderColumn(domElement, column, columnIndex, columnCssClass) {
        var articleListHml = renderArticleList(column, columnIndex);
        var columnHtml = [
            '<div class="column-cms ' + columnCssClass + '">' +
            '   <div class="box box-cms-grid">' + 
            '       <div class="box-heading-wrapper">' +
            '           <span class="box-heading">' + BEGUI.getInstance().translate('Converia_Admin_Module_Cms_SiteStructure_row_settings_column') + ' ' + (columnIndex + 1) + '</span>' +
            '       </div><!-- /.box-heading-wrapper -->' +

                    articleListHml + 

            '       <div class="button-control">' +
            '           <button type="button" class="button button-icon button-add" data-row-click="add-article" title="' + BEGUI.getInstance().translate('Converia_Admin_Module_Cms_SiteStructure_row_settings_add_article') + '" data-row-click-data="' + columnIndex + '">' +
            '               <span class="be-icon be-icon-add"></span>' +
            '           </button>' +
            '       </div>' +
            '   </div>' +
            '</div>'
        ].join('');

        $(domElement).append(columnHtml);
    }

    /**
     * renderArticleList
     * 
     * @param column
     * @param columnIndex
     * @returns {string}
     */
    function renderArticleList(column, columnIndex) {
        var articleList = [];
        var articlesInColumn = column.getArticles();

        for (var articleIndex = 0, articleListLength = articlesInColumn.length; articleIndex < articleListLength; articleIndex++) {
            var currentArticle = articlesInColumn[articleIndex];
            articleList.push(
                [
                    '<li class="data-list-item" data-row-article-list-entry="1" data-row-article-index="' + articleIndex + '">' +
                    '   <div class="data-list-item-action-wrapper">' +
                    '       <div class="data-list-item-action">' +
                    '           <a href="#" data-row-click="remove-article" data-row-column-index="' + columnIndex + '" data-row-article-index="' + articleIndex + '" title="' + BEGUI.getInstance().translate('Converia_Admin_Module_Cms_SiteStructure_row_settings_remove_article') + '">' +
                    '               <span class="be-icon be-icon-remove"></span>' +
                    '           </a>' +
                    '       </div>' +
                    '       <div class="data-list-item-action">' +
                    '           <a href="#" data-row-click="edit-article" data-row-column-index="' + columnIndex + '" data-row-article-index="' + articleIndex + '">' +
                    '               <span class="be-icon be-icon-edit"></span>' +
                    '           </a>' +
                    '       </div>' +
                    '       <div class="data-list-item-action">' +
                    '           <a href="#" data-row-sorter="1">' +
                    '               <span class="be-icon be-icon-draggable"></span>' +
                    '           </a>' +
                    '       </div>' +
                    '   </div>' +
                    '   <div class="data-list-item-element data-list-item-label">' +
                            currentArticle.getShownName() +
                    '   </div>' +
                    '</li>'
                ].join('')
            );
        }

        var articleHtml = [
            '<ul class="data-list data-list-cms-column-content" data-row-article-list="1" data-row-column-index="' + columnIndex + '">' +
                articleList.join('') +
            '</ul>'
        ].join('');

        return articleHtml;
    }

    /**
     * renderColumnSplitElement
     * 
     * @param domElement
     * @param options
     * @param currentSelectedValue
     */
    function renderColumnSplitElement(domElement, options, currentSelectedValue) {
        var optionsElements = [];
        $(options).each(
            function (index, value) {
                optionsElements.push(
                    [
                        '<option value="' + value + '" ' + ((value === currentSelectedValue) ? 'selected' : '') + ' >' +
                        BEGUI.getInstance().translate('Converia_Admin_Module_Cms_SiteStructure_row_settings_column_split_' + value) +
                        '</option>'
                    ].join('')
                );
            }
        );

        var columnHtml = [
            '<div class="row row-form">' +
            '   <div class="column column-form-element">' +
            '       <label>' +
                        BEGUI.getInstance().translate('Converia_Admin_Module_Cms_SiteStructure_row_settings_column_split') +
            '           <span class="required">*</span>' +
            '       </label>' +
            '       <select  data-row-change="change-column-split">' +
                        optionsElements.join('') +
            '       </select>' +
            '   </div>' +
            '</div>'
        ].join('');

        $(domElement).append(columnHtml);
    }

    /**
     * renderArticleBrowserSelectHelper
     * 
     * @param domElement
     * @returns {*|jQuery}
     */
    function renderArticleBrowserSelectHelper(domElement) {
        var date = new Date();
        var selectHtml = [
            '<select class="hide" id="article_select_' + date.getTime() + '" data-row-change="article-selected">' +
            '</select>'
        ].join('');

        var articleBrowserSelectElement = $(selectHtml).get(0);

        $(domElement).append(articleBrowserSelectElement);
        return articleBrowserSelectElement;
    }

    return View;
});
